var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.982,
    height: 18.982,
    viewBox: "0 0 18.982 18.982",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17323",
    "data-name": "Group 17323",
    transform: "translate(1657.807 1151.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11364",
    "data-name": "Path 11364",
    d: "M-1618.656-1103.148q0-6.209,0-12.417v-.248h3.777v1.761c.062-.078.09-.106.11-.139a3.991,3.991,0,0,1,2.972-1.895,5.98,5.98,0,0,1,2.317.129,3.611,3.611,0,0,1,2.722,2.656,8.915,8.915,0,0,1,.337,2.023c.007.1.023.206.035.308v7.823h-3.93c0-2.2,0-4.41-.009-6.615a8.211,8.211,0,0,0-.109-1.234,1.739,1.739,0,0,0-1.655-1.658,2.056,2.056,0,0,0-2.491,1.756,8.251,8.251,0,0,0-.14,1.526c-.016,2.075-.008,4.15-.009,6.226Z",
    transform: "translate(-32.44 -28.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11365",
    "data-name": "Path 11365",
    d: "M-1656.074-1101.538c0-.086.014-.172.014-.258q0-6.07,0-12.141v-.266h3.94v.247q0,6.08,0,12.159c0,.086.008.172.012.258Z",
    transform: "translate(-1.436 -30.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11366",
    "data-name": "Path 11366",
    d: "M-1655.592-1146.482a2.3,2.3,0,0,1-2.212-2.435,2.292,2.292,0,0,1,2.407-2.14,2.292,2.292,0,0,1,2.148,2.4A2.306,2.306,0,0,1-1655.592-1146.482Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkin);
export default __webpack_public_path__ + "static/media/linkin.d45831ab334724a00e0aa2f188f93355.svg";
export { ForwardRef as ReactComponent };